<label class="m-0 p-0 pr-3" *ngIf="town">
    <div [style.background-image]="town.icon | safeBgUrl" class="ca-logo"></div>
    <input (change)="uploadLogo($event)" *ngIf="Utils.userHasRights('USER')" hidden type="file">
</label>
